module.exports = "/assets/data/3c3c77e7cfabfa3d70fcc406295fcc4f-AL10.data.json";